let inject = ['$scope', '$uibModalInstance','modalOptions', 'SharedService', '$q', 'LoginService', '$filter'];

class ModalSelectClientController {
  constructor ($scope,$uibModalInstance,modalOptions, SharedService, $q, LoginService, $filter) {
    this.$scope = $scope;
    this.$q = $q;
    this.$filter = $filter;
    this.LoginService = LoginService;
    this.$uibModalInstance = $uibModalInstance;
    this.SharedService = SharedService;
    this.modalOptions = Object.assign({}, modalOptions);
    this.globals = this.modalOptions.globals;
    this.sellerQuoteFormDataHeader = {};
    this.sellerQuoteFormDataHeader.attendant = {};
    this.savingQuoteOrderCartSellerHeader = false;
    this.errorSavingQuoteOrderCartSellerHeader = false;
    this.errorMessageSavingQuoteOrderCartSellerHeader = '';
    this.errorMessagesSavingQuoteOrderCartSellerHeader = '';
    this.loadingOcasionalInformationHeader = false;
    this.errorloadingOcasionalInformationHeader = false;
    this.validatingNumberIdHeader = false;
    this.validatedNumberIdHeader = false;
    this.numberIdIsValidHeader = false;
    this.ocasionalClientExistHeader = false;
    this.terceroAsociadoOtroVendedor = false;
    this.loadingCitiesHeader = false;
    this.loadingContactByIdentificationNumberHeader = false;
    this.globalCities = {};
    this.globalCities.value = '';
    this.autocomplete_options = {
      suggest: (term) => {
        this.sellerQuoteFormDataHeader.destination = {};
        this.sellerQuoteFormDataHeader.destination.location = {};
        let q = term.toLowerCase().trim();
        let results = [];
        if (term.length > 3) {
          return this.$q((resolve, reject) => {
            this.loadingCitiesHeader = true;
            this.SharedService.getLocationBySearchText({'searchText': q}).then(response => {
              this.loadingCitiesHeader = false;
              if (!response.error) {
                angular.forEach(response, item => {
                  let locationName = item.cityName + ', ' + item.stateName + ', ' + item.countryName;
                  let result = {
                    label: this.$filter('toTrusted')(locationName),
                    value: this.$filter('toTrusted')(locationName),
                    item: item
                  };
                  results.push(result);
                })
              }
              resolve(results);
            }).catch(reason => {
              this.loadingCitiesHeader = false;
              reject(reason);
            });
          });
          
        }
      
      },
      on_error: console.log,
      on_select: data => {
        let item = data.item;
        let locationName = item.cityName + ', ' + item.stateName + ', ' + item.countryName;
        this.sellerQuoteFormDataHeader.destination.location = {
          "city": {
            "id": item.cityId,
            "name": item.cityName,
            "indicative": 2
          },
          "state": {
            "id": item.stateId,
            "name": item.stateName
          },
          "country": {
            "id": item.countryId,
            "name": item.countryName,
            "indicative": 57
          },
          "fullname": item.cityName + ', ' + item.stateName + ', ' + item.countryName
        };
      }
    };
    //// End: Mass -autocomplete - cities
  
    //// Begin: Mass - autocomplete - attendat names
    this.attendant_name_options = {
      suggest: term => {
        // this.sellerQuoteFormDataHeader.attendant = {};
        let q = term.toLowerCase().trim();
        let results = [];
        if (term.length > 2) {
          this.loadingAttendatNamesHeader = true;
          return this.$q((resolve, reject) => {
            this.loadingCitiesHeader = true;
            this.SharedService.getThirdBySearchText({'searchText': q}).then(response => {
              this.loadingAttendatNamesHeader = false;
              if (!response.error) {
                angular.forEach(response, item => {
                  let result = {
                    label: this.$filter('toTrusted')(item.name),
                    value: this.$filter('toTrusted')(item.name),
                    item: item
                  };
                  results.push(result);
                });
              }
              resolve(results);
            }).catch(reason => {
              this.loadingAttendatNamesHeader = false;
              reject(reason);
            });
          });
        }
      
      },
      on_error: console.log,
      on_select: data => {
        let documentNumber = data.item.documentNumber;
        this.preloadOcasionalInformationHeader(documentNumber);
      }
    };
    //// End: Mass -autocomplete
    this.activate();
  }
  
  activate(){}
  
  autosetAttendantClientTypeHeader() {
    this.sellerQuoteFormDataHeader.attendant.documentDV = '';
    
    if (this.sellerQuoteFormDataHeader.attendant.documentType === '2' || this.sellerQuoteFormDataHeader.attendant.documentType === '3') {
      this.sellerQuoteFormDataHeader.attendant.clientType = '2';
      
      $('#modalQuoteSellerHeader').find('#sellerQuoteAttendantDocumentNumberHeader').select();
    }
    else if (this.sellerQuoteFormDataHeader.attendant.documentType) {
      this.sellerQuoteFormDataHeader.attendant.clientType = '1';
      
      $('#modalQuoteSellerHeader').find('#sellerQuoteAttendantDocumentNumberHeader').select();
    }
    else {
      this.sellerQuoteFormDataHeader.attendant.clientType = '';
    }
  }
  
  clearNameCityHeader() {
    this.globalCities.value = '';
    this.sellerQuoteFormDataHeader.contact = {};
  }
  
  loadContactByIdentificacionNumberHeader (contactIdentificationNumber) {
    this.loadingContactByIdentificationNumberHeader = true;
    this.SharedService.getContactByIdentificationNumber({'numberId': contactIdentificationNumber}).then(response => {
      this.loadingContactByIdentificationNumberHeader = false;
      if (response.data) {
        if (response.data.contact && angular.isObject(response.data.contact)) {
          this.sellerQuoteFormDataHeader.contact = response.data.contact;
        } else {
          let documentType = this.sellerQuoteFormDataHeader.contact.documentType;
          let documentNumber = this.sellerQuoteFormDataHeader.contact.documentNumber;
          this.sellerQuoteFormDataHeader.contact = {};
          // Restore the info
          if (documentType)
            this.sellerQuoteFormDataHeader.contact.documentType = documentType;
          if (documentNumber)
            this.sellerQuoteFormDataHeader.contact.documentNumber = documentNumber;
        }
      }
    }).catch(reason => {
    
    });
  }
  
  setClientQuoteFormDataSeller (form) {
    if (!form.$valid) {
      angular.forEach(form.$error, (errorType) => {
        angular.forEach(errorType, (field) => {
          field.$setDirty();
        })
      });
      return false;
    }
    this.savingQuoteOrderCartSellerHeader = true;
    this.errorSavingQuoteOrderCartSellerHeader = false;
    this.errorMessageSavingQuoteOrderCartSellerHeader = '';
    this.errorMessagesSavingQuoteOrderCartSellerHeader = '';
    let cityId = this.sellerQuoteFormDataHeader.destination.location.city.id;
    this.SharedService.updateInfoClientSelected({'sellerQuoteFormData': this.sellerQuoteFormDataHeader, 'cityId': cityId}).then(response => {
      this.savingQuoteOrderCartSellerHeader = false;
      if (response.error) {
        this.errorSavingQuoteOrderCartSellerHeader = true;
        this.errorMessageSavingQuoteOrderCartSellerHeader = response.message;
        this.errorMessagesSavingQuoteOrderCartSellerHeader = response.errors;
      } else {
        let data = response.data;
    
        let firstname = data.contact.primerNombre;
        if (data.contact.segundoNombre) {
          firstname += ' ' + data.contact.segundoNombre;
        }
    
        let lastname = data.contact.primerApellido;
        if (data.contact.segundoApellido) {
          lastname += ' ' + data.contact.segundoApellido;
        }
        this.globals.currentClient = {
          "id": data.contact.id,
          "userId": data.user.id,
          "name": firstname + ' ' + lastname,
          "firstname": firstname,
          "lastname": lastname,
          "position": data.contact.cargo,
          "email": data.contact.email,
          "phone": data.contact.telefono,
          "mobile": data.contact.movil,
          "documentNumber": data.contact.documento_numero,
          "documentTypeId": data.contact.documento_tipo_id,
          "documentTypeName": data.contact.documento_tipo_nombre,
          "third": {
            "id": data.third.id,
            "name": data.third.nombre,
            "attendantTypeId": data.third.tipo_persona_id,
            "attendantTypeName": data.third.tipo_persona_nombre,
            "documentTypeId": data.third.documento_tipo_id,
            "documentTypeName": data.third.documento_tipo_nombre,
            "documentNumber": data.third.documento_numero,
            "documentDV": data.third.documento_dv,
            "website": data.third.web_site,
            "isB2B": data.third.isB2B
          },
          "contact": {
            "id": data.contact.id,
            "name": firstname + ' ' + lastname,
            "firstname": firstname,
            "lastname": lastname,
            "position": data.contact.cargo,
            "email": data.contact.email,
            "phone": data.contact.telefono,
            "mobile": data.contact.movil,
            "documentTypeId": data.contact.documento_tipo_id,
            "documentTypeName": data.contact.documento_tipo_nombre,
            "documentNumber": data.contact.documento_numero,
            "whatsappNumber": "",
            "secondaryEmail": "",
            "seller": data.contact.seller
          },
          "operatingCenter": {
            "id": data.operatingCenter.id,
            "code": data.operatingCenter.referencia,
            "name": data.operatingCenter.nombre,
            "phone": data.operatingCenter.telefono_principal,
            "address": data.operatingCenter.direccion_principal,
            "location": data.operatingCenter.location
          }
        };
        // Set the current client
        this.globals.currentUser.userId = data.user.id;
        this.ok();
      }
    }).catch(reason => {
      this.errorSavingQuoteOrderCartSellerHeader = true;
      this.savingQuoteOrderCartSellerHeader = false;
      this.errorMessageSavingQuoteOrderCartSellerHeader = 'Ha ocurrido un error al cargar el cliente.';
    });
    
  }
  
  validateNumberIdUnusedHeader (numberId) {
    if (numberId) {
      this.validatingNumberIdHeader = true;
      this.validatedNumberIdHeader = false;
      this.numberIdIsValidHeader = false;
      this.ocasionalClientExistHeader = false;
      this.terceroAsociadoOtroVendedor = false;
      let userId = '';
      try {
        userId = this.globals.currentUser.sellerId;
      }
      catch (e) {
      }
      // Send the request
      this.SharedService.validateNumberIdUnusedHeader({'numberId': numberId, 'validateIfIsOcasionalClient': 1, 'userId': userId}).then(response => {
        this.validatingNumberIdHeader = false;
        this.validatedNumberIdHeader = true;
  
        if (!response.error) {
          this.numberIdIsValidHeader = true;
    
          let documentType = this.sellerQuoteFormDataHeader.attendant.documentType;
          let clientType = this.sellerQuoteFormDataHeader.attendant.clientType;
    
          // Clean the data
          this.sellerQuoteFormDataHeader = {};
          this.sellerQuoteFormDataHeader.attendant = {};
    
          // Restore only the data needed
          this.sellerQuoteFormDataHeader.attendant.documentType = documentType;
          this.sellerQuoteFormDataHeader.attendant.clientType = clientType;
          this.sellerQuoteFormDataHeader.attendant.documentNumber = numberId;
        }
        else if (response.errorCode === 'ERROR-CLIENTE-OCASIONAL-EXISTE'
          || response.errorCode === 'ERROR-TERCERO-EXISTE') {
          this.numberIdIsValidHeader = true;
          this.ocasionalClientExistHeader = true;
    
          this.preloadOcasionalInformationHeader(numberId);
        }
        else {
    
          if (response.errorCode === 'ERROR-TERCERO-ASIGNADO-OTRO-VENDEDOR') {
            // Clean the data
            this.sellerQuoteFormDataHeader = {};
            this.sellerQuoteFormDataHeader.attendant = {};
            this.sellerQuoteFormDataHeader.attendant.documentNumber = numberId;
      
            this.terceroAsociadoOtroVendedor = true;
            this.numberIdIsValidHeader = true;
          }
          else if (response.errorCode === 'ERROR-TERCERO-NO-HABILITADO') {
            // Clean the data
            this.sellerQuoteFormDataHeader = {};
            this.sellerQuoteFormDataHeader.attendant = {};
            this.sellerQuoteFormDataHeader.attendant.documentNumber = numberId;
      
            this.thirdIsInactive = true;
            this.numberIdIsValidHeader = true;
          }
          else {
            this.numberIdIsValidHeader = false;
          }
        }
      }).catch(reason => {
        this.validatingNumberIdHeader = false;
        this.validatedNumberIdHeader = true;
        this.numberIdIsValidHeader = false;
      });
    }
  }
  
  validateEmailUnusedHeader () {
    let contactId = this.sellerQuoteFormDataHeader.contact.id;
    let contactEmail = this.sellerQuoteFormDataHeader.contact.principalEmail;
    if (!contactId && contactEmail) {
      this.sellerQuoteFormDataHeader.contact.validatingEmail = true;
      this.sellerQuoteFormDataHeader.contact.validatedEmail = false;
      this.sellerQuoteFormDataHeader.contact.emailIsValid = true;
      // Send the request
      this.SharedService.validateEmailUnusedHeader({'email': contactEmail}).then(response => {
        this.sellerQuoteFormDataHeader.contact.validatingEmail = false;
        this.sellerQuoteFormDataHeader.contact.validatedEmail = true;
        this.sellerQuoteFormDataHeader.contact.emailIsValid = !response.error;
      }).catch(reason => {
        this.sellerQuoteFormDataHeader.contact.validatingEmail = false;
        this.sellerQuoteFormDataHeader.contact.validatedEmail = true;
        this.sellerQuoteFormDataHeader.contact.emailIsValid = false;
      });
      
    }
  }
  
  preloadOcasionalInformationHeader (documentNumber) {
    this.loadingOcasionalInformationHeader = true;
    this.errorloadingOcasionalInformationHeader = false;
    
    let cityId = '';
    // Send the request
    this.SharedService.getOcasionalInformation({'documentNumber': documentNumber, 'cityId': cityId}).then(response => {
      this.loadingOcasionalInformationHeader = false;
      if (!response.error) {
        if (response.data) {
          // If a client is already selected
          let thirdId = '';
          try {
            thirdId = this.globals.currentClient.third.id;
          }
          catch (e) {
          }
      
          if (thirdId) {
            this.sellerQuoteFormDataHeader.destinations = response.data.destinations;
            this.sellerQuoteFormDataHeader.contacts = response.data.contacts;
        
            this.sellerQuoteFormDataHeader.attendant = {
              id: response.data.attendant.id,
              documentType: response.data.attendant.documentType,
              documentTypeName: response.data.attendant.documentTypeName, // TODO
              documentNumber: response.data.attendant.documentNumber,
              documentDV: response.data.attendant.documentDV,
              clientType: response.data.attendant.clientType,
              clientTypeName: response.data.attendant.clientTypeName,
              name: response.data.attendant.name
            }
          }
          else {
            this.sellerQuoteFormDataHeader = response.data;
            this.sellerQuoteFormDataHeader.destination = {};
            this.sellerQuoteFormDataHeader.contact = {};
          }
      
        }
        else {
          this.sellerQuoteFormDataHeader = {};
        }
      }
      else {
        this.errorloadingOcasionalInformationHeader = true;
      }
    }).catch(reason => {
      this.loadingOcasionalInformationHeader = false;
      this.errorloadingOcasionalInformationHeader = true;
    });
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.$uibModalInstance.close(this.globals);
  }
}

ModalSelectClientController.$inject = inject;

export default ModalSelectClientController;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/shared/components/modal-select-client/modal-select-client.controller.js
 **/